export default {
  Course: {
    CourseCard: 'Giỏ học liệu',
    CourseEmpty: 'Chưa có học liệu',
    CourseExplore: 'khám phá thêm các khóa học',
    NotRegisteredCourse: 'Bạn chưa đăng ký học khóa học nào',
    PaymentInfo: 'Thông tin thanh toán',
    FullName: 'Họ tên',
    InputFullName: 'Nhập họ tên',
    Address: 'Địa chỉ',
    InputAddress: 'Nhập địa chỉ',
    ReceiveInvoice: 'Nhận hóa đơn',
    EmailReceiveInvoice: 'Email nhận hóa đơn',
    StudyRegister: 'Đăng ký học',
    Total: 'Tổng cộng',
    Sale: 'Khuyến mại',
    PayMoney: 'Tiền phải trả',
    NumberLessonAndSource: '{number} bài giảng - HOCMAI.VN',
    SelectedCourse: 'khóa học đang chọn',
    GradeCourse: '{courseNumber} khóa học khối {grade}',
    SaleCombo: 'Gói khuyến mại khi mua cùng',
    SelectQuanlityCourse: 'Chọn {quantity} trong những khóa học dưới đây',
    CourseGive: 'Bạn được tặng kèm {numberCourse} khóa học trong danh sách sau khi đăng ký học khóa học này:',
    NotFilledEnoughInfo: 'Bạn chưa điền đủ thông tin',
    CourseDeleteTooltip: 'Xóa khóa học',
    AreYouSureDelete: 'Bạn có chắc chắn muốn xóa khóa học?',
    ButtonConfirmDelete: 'Xóa',
    AreYouSureRegisterCourse: 'Bạn có chắc muốn đăng ký học khóa học này không?',
    AreYouSureRegisterCourseWithNumber: 'Bạn có chắc muốn đăng ký học {amount} khóa học này không?',
    ButtonConfirmRegister: 'Đăng ký học',
    SendSupport: 'Cảm ơn bạn đã gửi yêu cầu hỗ trợ',
    InformationHelp: 'Những thông tin bạn góp ý sẽ giúp đỡ chúng tớ rất nhiều',
    ErrorSupportHOCMAI: 'Báo lỗi video {videoName} trong {lessonName}, {themeName}, {topicName}, {courseName}', // Nội dung render HOCMAI
    ErrorSupportIGIAODUC: 'Báo lỗi video {videoName} trong {courseName}', // Nội dung render IGIAODUC
    ErrorExerciseCompose: 'Báo lỗi Câu {numberQuestion} trong {exerciseTitle}',
    ErrorExerciseUpload: 'Báo lỗi bài {exerciseTitle}',
    TitleConfirmRegister: 'Xác nhận đơn đăng ký học',
    NumberOfRegisterLesson: 'Bạn đang đăng ký<b> {amount} khóa học.</b>',
    DurationOfCourse: 'Khóa học sẽ có thời hạn sử dụng là 12 tháng kể từ ngày kích hoạt thành công.',
    ButtonBack: 'Quay lại',
    ButtonRegister: 'Tạo đơn đăng ký'
  }
}
